import { AxiosResponse } from 'axios';
import HttpClientWithRetry from '../http/client/HttpClientWithRetry';
import { AccountConfiguration } from '../modules/administration/accountParameter/accountParameter.types';

export class AccountLevelConfigurationController {
  constructor(private readonly httpClient: HttpClientWithRetry) {}

  async addUnresponsivePeriod(
    unresponsiveDismissPeriod: number,
    unresponsiveAgedPeriod: number,
    accountID: string,
  ): Promise<AxiosResponse> {
    const reqObj = {
      configuration: {
        unresponsiveAgedPeriod,
        unresponsiveDismissPeriod,
      },
    };
    const path = `api/v1/accounts/${accountID}/configuration`;
    return this.httpClient.put(path, reqObj);
  }

  async updateAccountConfiguration(accountId: string, configuration: Partial<AccountConfiguration>): Promise<AxiosResponse> {
    const path = `/api/v2/account/${accountId}/configuration`;
    return this.httpClient.put(path, { configuration });
  }
}
